import { Column, Row } from '@unistocks/components/layout/flex';
import { Table } from '@unistocks/components/table/table';
import { Paragraph } from '@unistocks/components/text/text';
import { AssetImage } from '@unistocks/features/assets/components/asset-image';
import { AdminAssetDto } from '@unistocks/proxy/axios-client';
import { SUBTITLE_OPACITY } from '@unistocks/shared/consts';
import { formatCurrency, formatDateTime, t } from '@unistocks/shared/localization/index.ts';
import { assetTypeOptions } from '@unistocks/shared/utils/enums/asset-type-options';
import { dataSourceOptions } from '@unistocks/shared/utils/enums/data-source-options';
import { isNumber } from '@unistocks/shared/utils/util';
import { GetProps } from 'tamagui';

export type AssetListRowProps = GetProps<typeof Table.Row> & {
  asset: AdminAssetDto;
};

export const AssetListRow: React.FC<AssetListRowProps> = ({ asset, ...props }) => {
  return (
    <Table.Row key={asset.id} pressable={false} hoverable={false} {...props}>
      <Table.Cell cellLocation="first" cellWidth={'$16'}>
        <Row gap={'$3'} w={'100%'}>
          <AssetImage
            asset={asset}
            size={'$2.5'}
            display="none"
            $md={{ display: 'block', alignSelf: 'center' }}
          />
          <Column>
            <Paragraph>{asset.name}</Paragraph>
            <Paragraph size={'$2'} o={SUBTITLE_OPACITY}>
              {asset.symbol ?? asset.isin ?? '-'}
            </Paragraph>
          </Column>
        </Row>
      </Table.Cell>
      <Table.Cell cellLocation="middle">
        <Column>
          <Paragraph>
            {t(assetTypeOptions.find(option => option.value === asset.type)!.key)}
          </Paragraph>
          <Paragraph size={'$2'} o={SUBTITLE_OPACITY}>
            {dataSourceOptions.find(option => option.value === asset.dataSource)?.key ?? '-'}
          </Paragraph>
        </Column>
      </Table.Cell>
      <Table.Cell cellLocation="middle">
        <Paragraph>{asset.figi ?? '-'}</Paragraph>
      </Table.Cell>
      <Table.Cell cellLocation="middle" alignCells={{ x: 'end' }}>
        <Paragraph>
          {isNumber(asset.currentPrice)
            ? formatCurrency(asset.currentPrice, asset.currency, {
                currencyDisplay: 'code'
              })
            : '-'}
        </Paragraph>
      </Table.Cell>
      <Table.Cell cellLocation="last" alignCells={{ x: 'end' }}>
        <Paragraph>
          {asset.updated
            ? formatDateTime(asset.updated, {
                dateStyle: 'medium',
                timeStyle: 'short'
              })
            : '-'}
        </Paragraph>
      </Table.Cell>
    </Table.Row>
  );
};

AssetListRow.displayName = 'AssetListRow';
